import { ACTIVATION_SELECT_ENABLE } from "./ItemMyStatBase"


export const TITLE_player_name = '中文姓名'
export const TITLE_player_name_eng = '英文姓名'
export const TITLE_player_DOB = '出生年月日'
export const TITLE_player_id = '編號'
export const TITLE_player_activation = '啟停用'
export const TITLE_player_last_change = '異動日期'
export const TITLE_player_position = '預設守備'
export const TITLE_player_throw_bat = '投打習慣'
export const TITLE_player_height = '身高-CM'
export const TITLE_player_weight = '體重-KG'
export const TITLE_player_note = '註記'
export const TITLE_player_pic_profile = '球員照片'
export const TITLE_player_pic_game = '球員背景'


export const POSITION_PITCHER = 1
export const POSITION_CATCHER = 2
export const POSITION_FIRST_BASEMAN = 3
export const POSITION_SECOND_BASEMAN = 4
export const POSITION_THIRD_BASEMAN = 5
export const POSITION_SHORTSTOP = 6
export const POSITION_LEFT_FIELD = 7
export const POSITION_CENTER_FIELDER = 8
export const POSITION_RIGHT_FIELD = 9
export const POSITION_DESIGNATED_HITTER = 10

export const POSITION_PITCHER_STRING = '投手'
export const POSITION_CATCHER_STRING = '捕手'
export const POSITION_FIRST_BASEMAN_STRING = '一壘手'
export const POSITION_SECOND_BASEMAN_STRING = '二壘手'
export const POSITION_THIRD_BASEMAN_STRING = '三壘手'
export const POSITION_SHORTSTOP_STRING = '游擊手'
export const POSITION_LEFT_FIELD_STRING = '左外野'
export const POSITION_CENTER_FIELDER_STRING = '中外野'
export const POSITION_RIGHT_FIELD_STRING = '右外野'
// export const POSITION_DESIGNATED_HITTER_STRING = '指定打擊'

export const player_position_attr = [
    { val: POSITION_PITCHER, name: POSITION_PITCHER_STRING },
    { val: POSITION_CATCHER, name: POSITION_CATCHER_STRING },
    { val: POSITION_FIRST_BASEMAN, name: POSITION_FIRST_BASEMAN_STRING },
    { val: POSITION_SECOND_BASEMAN, name: POSITION_SECOND_BASEMAN_STRING },
    { val: POSITION_THIRD_BASEMAN, name: POSITION_THIRD_BASEMAN_STRING },
    { val: POSITION_SHORTSTOP, name: POSITION_SHORTSTOP_STRING },
    { val: POSITION_LEFT_FIELD, name: POSITION_LEFT_FIELD_STRING },
    { val: POSITION_CENTER_FIELDER, name: POSITION_CENTER_FIELDER_STRING },
    { val: POSITION_RIGHT_FIELD, name: POSITION_RIGHT_FIELD_STRING },
    // { val: POSITION_DESIGNATED_HITTER, name: POSITION_DESIGNATED_HITTER_STRING },
]

export function get_player_position_string(val) {
    if(typeof(val) === 'string'){
        val = parseInt(val)
    }
    switch (val) {
        case POSITION_PITCHER:
            return POSITION_PITCHER_STRING
        case POSITION_CATCHER:
            return POSITION_CATCHER_STRING
        case POSITION_FIRST_BASEMAN:
            return POSITION_FIRST_BASEMAN_STRING
        case POSITION_SECOND_BASEMAN:
            return POSITION_SECOND_BASEMAN_STRING
        case POSITION_THIRD_BASEMAN:
            return POSITION_THIRD_BASEMAN_STRING
        case POSITION_SHORTSTOP:
            return POSITION_SHORTSTOP_STRING
        case POSITION_LEFT_FIELD:
            return POSITION_LEFT_FIELD_STRING
        case POSITION_CENTER_FIELDER:
            return POSITION_CENTER_FIELDER_STRING
        case POSITION_RIGHT_FIELD:
            return POSITION_RIGHT_FIELD_STRING
        // case POSITION_DESIGNATED_HITTER:
        //     return POSITION_DESIGNATED_HITTER_STRING
        default:
            return ""
    }
}

export const THROW_BAT_RS_RH = 1
export const THROW_BAT_RS_LH = 2
export const THROW_BAT_RS_BH = 3
export const THROW_BAT_LS_RH = 4
export const THROW_BAT_LS_LH = 5
export const THROW_BAT_LS_BH = 6
export const THROW_BAT_BS_RH = 7
export const THROW_BAT_BS_LH = 8
export const THROW_BAT_BS_BH = 9

export const THROW_BAT_RS_RH_STRING = '右投/右打'
export const THROW_BAT_RS_LH_STRING = '右投/左打'
export const THROW_BAT_RS_BH_STRING = '右投/兩打'
export const THROW_BAT_LS_RH_STRING = '左投/右打'
export const THROW_BAT_LS_LH_STRING = '左投/左打'
export const THROW_BAT_LS_BH_STRING = '左投/兩打'
export const THROW_BAT_BS_RH_STRING = '兩投/右打'
export const THROW_BAT_BS_LH_STRING = '兩投/左打'
export const THROW_BAT_BS_BH_STRING = '兩投/兩打'

export const player_throw_bat_attr = [
    { val: THROW_BAT_RS_RH, name: THROW_BAT_RS_RH_STRING },
    { val: THROW_BAT_RS_LH, name: THROW_BAT_RS_LH_STRING },
    { val: THROW_BAT_RS_BH, name: THROW_BAT_RS_BH_STRING },
    { val: THROW_BAT_LS_RH, name: THROW_BAT_LS_RH_STRING },
    { val: THROW_BAT_LS_LH, name: THROW_BAT_LS_LH_STRING },
    { val: THROW_BAT_LS_BH, name: THROW_BAT_LS_BH_STRING },
    { val: THROW_BAT_BS_RH, name: THROW_BAT_BS_RH_STRING },
    { val: THROW_BAT_BS_LH, name: THROW_BAT_BS_LH_STRING },
    { val: THROW_BAT_BS_BH, name: THROW_BAT_BS_BH_STRING },
]


export function get_player_throw_bat_string(val) {
    if(typeof(val) === 'string'){
        val = parseInt(val)
    }
    // console.log(typeof(val))
    switch (val) {
        case THROW_BAT_RS_RH:
            return THROW_BAT_RS_RH_STRING
        case THROW_BAT_RS_LH:
            return THROW_BAT_RS_LH_STRING
        case THROW_BAT_RS_BH:
            return THROW_BAT_RS_BH_STRING
        case THROW_BAT_LS_RH:
            return THROW_BAT_LS_RH_STRING
        case THROW_BAT_LS_LH:
            return THROW_BAT_LS_LH_STRING
        case THROW_BAT_LS_BH:
            return THROW_BAT_LS_BH_STRING
        case THROW_BAT_BS_RH:
            return THROW_BAT_BS_RH_STRING
        case THROW_BAT_BS_LH:
            return THROW_BAT_BS_LH_STRING
        case THROW_BAT_BS_BH:
            return THROW_BAT_BS_BH_STRING
        default:
            return ""
    }
}


export class ReqPlayerList {
    constructor({ start, limit, player_name = "", team_id = "", player_activation = ACTIVATION_SELECT_ENABLE }) {
        this.start = start
        this.limit = limit
        this.player_name = player_name
        this.team_id = team_id
        this.player_activation = player_activation
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.player_name = jsonData.player_name || ""
        this.team_id = jsonData.team_id || ""
        this.player_activation = jsonData.player_activation
    }

    get_player_activation() {
        return this.player_activation === 1 ? true : false
    }
}

export class ReqPlayerDetail {
    constructor({ player_id }) {
        this.player_id = player_id
    }
    fromJson(jsonData) {
        this.player_id = jsonData.player_id
    }
}

export class RespPlayer {
    constructor({ player_id, player_name, player_name_eng, player_DOB, player_activation, player_last_change, player_position, player_throw_bat, player_height, player_weight, player_note, player_pic_profile, player_pic_profile_auth, player_pic_profile_date, player_pic_game, player_pic_game_auth, player_pic_game_date }) {
        this.player_id = player_id
        this.player_name = player_name
        this.player_name_eng = player_name_eng
        this.player_DOB = player_DOB
        this.player_activation = player_activation
        this.player_last_change = player_last_change
        this.player_position = player_position
        this.player_throw_bat = player_throw_bat
        this.player_height = player_height
        this.player_weight = player_weight
        this.player_note = player_note
        this.player_pic_profile = player_pic_profile
        this.player_pic_profile_auth = player_pic_profile_auth
        this.player_pic_profile_date = player_pic_profile_date
        this.player_pic_game = player_pic_game
        this.player_pic_game_auth = player_pic_game_auth
        this.player_pic_game_date = player_pic_game_date
    }

    fromJson(jsonData) {
        this.id = jsonData._id
        this.player_id = jsonData.player_id
        this.player_name = jsonData.player_name
        this.player_name_eng = jsonData.player_name_eng
        this.player_DOB = jsonData.player_DOB
        this.player_activation = jsonData.player_activation
        this.player_last_change = jsonData.player_last_change
        this.player_position = jsonData.player_position
        this.player_throw_bat = jsonData.player_throw_bat
        this.player_height = jsonData.player_height
        this.player_weight = jsonData.player_weight
        this.player_note = jsonData.player_note
        this.player_pic_profile = jsonData.player_pic_profile
        this.player_pic_profile_auth = jsonData.player_pic_profile_auth
        this.player_pic_profile_date = jsonData.player_pic_profile_date
        this.player_pic_game = jsonData.player_pic_game
        this.player_pic_game_auth = jsonData.player_pic_game_auth
        this.player_pic_game_date = jsonData.player_pic_game_date
    }
}